export const defaultState = {
  name: '',
  country: null,
  initials: '',
  memberAssociation: null,
  cbHeadName: '',
  cbHeadEmail: '',
  cbHeadTelephone: '',
  contactName: '',
  contactEmail: '',
  contactTelephone: '',
  address: {
    line1: '',
    line2: '',
    postCode: '',
    city: '',
    country: null,
  },
  invoiceAddressSame: true,
  invoiceAddress: {
    line1: '',
    line2: '',
    postCode: '',
    city: '',
    country: null,
  },
  vatId: '',
  user: null,
  selectedUser: null,
  suspended: null,
  operational: null,
};

const SET_EDIT_DATA = 'SET_EDIT_DATA';
const UPDATE_FIELD = 'UPDATE_FIELD';

export const setEditDataCreator = (payload) => ({ type: SET_EDIT_DATA, payload });
export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });

export default function (state = defaultState, action) {
  if (action.type === SET_EDIT_DATA) {
    return {
      ...state,
      ...action.payload,
      address: { ...action.payload.address, country: action.payload.address?.country?.id },
      country: action.payload.country?.id,
      memberAssociation: action.payload.memberAssociation?.id,
      user: action.payload.user?.id,
      selectedUser: action.payload.user ? {value: action.payload.user.id, label: `${action.payload.user.firstName} ${action.payload.user.lastName}`} : null,
    };
  }
  if (action.type === UPDATE_FIELD) {
    return { ...state, [action.payload.name]: action.payload.value };
  }

  return state;
} 